import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import {
  IRichMailError,
  isGmailScopeError,
  richMailErrorKey,
  richMailSendErrorKey,
} from './richMailModel';

/**
 * Текст ошибки ТЗ 0097 на языке экрана. Незнакомый код — текст сервера,
 * а без него — общие слова.
 */
export const useRichMailErrorText = () => {
  const { t } = useTranslation();
  return useCallback(
    (
      error:
        | (Partial<IRichMailError> & { field?: string | null })
        | null
        | undefined,
    ): string => {
      if (!error) return '';
      const sendKey = richMailSendErrorKey(error);
      if (sendKey) return t(sendKey);
      const code = (error.code || '').toUpperCase();
      const message = error.message || '';
      if (isGmailScopeError({ code, message })) {
        return t('richMail.errors.GMAIL_SCOPE');
      }
      const key = richMailErrorKey(code);
      if (key) return t(key);
      return message || t('richMail.errors.unknown');
    },
    [t],
  );
};
